import { connect } from 'react-redux'

import {
  fetchInitialData,
} from '../actions'

import AddPublicHolidayComponent from '../components/AddPublicHolidayComponent'

const mapStateToProps = (state) => {
  return {
    publicholiday: state.publicholiday,
  }
}

const mapDispatchToProps = (dispatch) => ({
  fetchData: () => dispatch(fetchInitialData()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddPublicHolidayComponent)
